import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import Axios from 'axios';
import load from '../assets/loading.gif'
import { BASE } from '../api/api';

class Forgot_pwd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            name: '',
            tpwd: '',
            pwd: '',
            pwd_reset: false

        };
    }

    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }



    send_mail(rst) {
        if (this.state.pwd_reset == false && !rst) {
            if (this.state.email) {

                this.setState({
                    load: true
                })
                Axios({
                    url: BASE + 'user/lost-password?_format=json',
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    data: {
                        "mail": this.state.email
                    }
                })
                    .then((data) => {
                        this.setState({
                            pwd_reset: true,
                            load: false
                        })
                        this.fillalert('Repalcement login information has been sent to your registered Email ID(Please check your spam folder also)')
                    })
                    .catch((err) => {
                        this.fillalert(err.response.data.message)
                        this.setState({
                            load: false
                        })
                    })
            } else {
                this.setState({
                    emailalert: true
                })
            }

        }
        else if (rst) {
            if (this.state.tpwd.length > 0 && this.state.name.length > 0 && this.state.pwd.length > 0) {
                this.setState({
                    load: true
                })
                Axios({
                    url: BASE + 'user/lost-password-reset?_format=json',
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    data: {
                        "name": this.state.name,
                        "temp_pass": this.state.tpwd,
                        "new_pass": this.state.pwd
                    }
                })
                    .then((dt) => {
                        this.fillalert(dt.data.message)
                        this.props.history.push('/login')
                        this.setState({
                            load: false
                        })
                    })
                    .catch((err) => {
                        this.fillalert(err.response.data.message)
                        this.setState({
                            load: false
                        })
                    })
            }

            else {
                this.topFunction()
                this.setState({
                    namealert: true,
                    tpwdalert: true,
                    pwdalert: true
                })
            }
        }
    }

    fillalert(msg) {
        this.topFunction()
        this.setState({
            filltext: msg,
            fillalert: true
        })
        setTimeout(
            function () {
                this.setState({
                    fillalert: null
                })
            }
                .bind(this),
            3000
        );
    }

    render() {
        return (
            <div className='signuppage'>
                {this.state.load ? <div className='loading'>
                    <img src={load} alt='load' />
                </div> : ''}
                {this.state.fillalert ? <div className={this.state.filltext === 'Repalcement login information has been sent to your registered Email ID(Please check your spam folder also)' ? "fill-alert fill-success" : "fill-alert"}>{this.state.filltext}</div> : ''}
                <Header />
                <div className="listing" style={{ margin: '0 auto' }}>
                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="container">
                                <h1 className="sign-heading">Reset Password</h1>
                            </div>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="container">
                            <div className="row">
                                <div className="region region-content">
                                    <form className="webform-client-form webform-client-form-275" id="webform-client-form-275" accept-charset="UTF-8">
                                        <div>
                                            <div className="form-component" style={{ display: this.state.pwd_reset === false ? '' : 'none' }}>
                                                <label for="edit-submitted-email">Email <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="email" name="email" type="text" placeholder="Email*" value={this.state.email}
                                                    onChange={(e) => this.setState({ email: e.target.value })} />
                                                {this.state.emailalert && !this.state.email ?
                                                    <div class="alert-tag">The <strong>Email</strong> cannot be empty</div> : null}
                                            </div>
                                            <div className="form-component" style={{ display: this.state.pwd_reset === true ? '' : 'none' }}>
                                                <label for="edit-submitted-name">Username <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="name" name="name" placeholder="User Name*" type="text" value={this.state.name}
                                                    onChange={(e) => this.setState({ name: e.target.value })} />
                                                {this.state.namealert && !this.state.name ?
                                                    <div class="alert-tag">The <strong>Username</strong> cannot be empty</div> : null}
                                            </div>
                                            <div className="form-component" style={{ display: this.state.pwd_reset === true ? '' : 'none' }}>
                                                <label for="edit-submitted-tmppwd">Temporary Password <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="tmppwd" name="tmppwd" type="password" placeholder="Temporary Password*" value={this.state.tpwd}
                                                    onChange={(e) => this.setState({ tpwd: e.target.value })} />
                                                {this.state.tpwdalert && !this.state.tpwd ?
                                                    <div class="alert-tag">The <strong>Temporary Password</strong> cannot be empty</div> : null}
                                            </div>
                                            <div className="form-component" style={{ display: this.state.pwd_reset === true ? '' : 'none' }}>
                                                <label for="edit-submitted-pwd"> New Password <span className="form-required" title="This field is required.">*</span></label>
                                                <input id="pwd" name="pwd" type="password" placeholder="New Password*" value={this.state.pwd}
                                                    onChange={(e) => this.setState({ pwd: e.target.value })} />
                                                {this.state.pwdalert && !this.state.pwd ?
                                                    <div class="alert-tag">The <strong>New Password</strong> cannot be empty</div> : null}
                                            </div>
                                            <div className="cf">
                                                <div className="login_submit pointer" onClick={() => this.state.pwd_reset === true ? this.send_mail("reset") : this.send_mail()} ><div className='button-sign'>{this.state.pwd_reset === true ? 'Submit' : 'Send Email'}</div></div>
                                            </div>

                                            <div className="anchor_lnks">
                                                <a onClick={() => (this.setState({
                                                    name: '',
                                                    tpwd: '',
                                                    email: '',
                                                    pwd: ''
                                                }), this.props.history.push('/login'))}>Already a user? Login</a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Forgot_pwd;